import { FC, ReactElement } from 'react';
import { Box } from '@material-ui/core';

import { Typography } from '@components';
import { textTemplate } from '@utils';
import { content } from '@content';

export const DashboardCopyright: FC = (): ReactElement => (
  <Box mt="2.2rem" pb="2rem" textAlign="center">
    <Typography.Caption>
      &copy;&nbsp;
      {textTemplate(content.copyright, { year: new Date().getFullYear(), company: content.company })}
    </Typography.Caption>
  </Box>
);
